import React from 'react';
import { Link } from 'react-router-dom';
import { motion, useReducedMotion } from 'framer-motion';
import { ArrowRightIcon, CalendarDaysIcon, HandshakeIcon, PlayIcon, ScrollTextIcon, UsersIcon } from 'lucide-react';
import { HERO, KEY_FIGURES } from '../data/site';
import { DOJO_KUN } from '../data/club';
import { NEWS } from '../data/calendar';
import { SectionHeading } from '../components/SectionHeading';
const RUBRIQUES = [{
  to: '/le-club',
  label: 'Le Club',
  text: 'Histoire, valeurs, enseignants, bureau et dossier de presse.',
  Icon: UsersIcon
}, {
  to: '/informations-pratiques',
  label: 'Informations pratiques',
  text: 'Tarifs, inscriptions Hello Asso, horaires et lieu d’entraînement.',
  Icon: ScrollTextIcon
}, {
  to: '/calendrier',
  label: 'Calendrier',
  text: 'Compétitions, évènements adhérents, stages et démonstrations.',
  Icon: CalendarDaysIcon
}, {
  to: '/partenaires',
  label: 'Partenaires',
  text: 'Sponsors, partenaires institutionnels et mécénat.',
  Icon: HandshakeIcon
}];
export function Home() {
  const reduce = useReducedMotion();
  return <>
      <section className="relative overflow-hidden border-b border-gold/15" data-id="element-241" data-mp="2vyhwodlw1axm">
        <img src={HERO.image} alt="Karatékas du club alignés lors d’un kata dans le dojo" className="absolute inset-0 h-full w-full object-cover opacity-40" data-id="element-242" data-mp="2qxaowejqwbqy" />
        <div aria-hidden className="absolute inset-0 bg-ink/75" data-id="element-243" data-mp="2hyp6cje9wwq6" />
        <span aria-hidden className="pointer-events-none absolute -left-6 top-6 select-none font-jp text-[8rem] leading-none text-white/[0.05] lg:text-[14rem]" data-id="element-244" data-mp="2d6p1qdn9dfn9">
          空手道
        </span>

        <div className="relative mx-auto max-w-shell px-5 py-16 lg:px-8 lg:py-24" data-id="element-245" data-mp="23a2fbkfaagj4">
          <motion.div initial={reduce ? false : {
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.28,
          ease: [0.23, 1, 0.32, 1]
        }} className="grid items-center gap-12 lg:grid-cols-[1.15fr_1fr]" data-id="element-246" data-mp="1z7xsb4jcci5g">
            <div data-id="element-247" data-mp="1om2hhyacvnt0">
              <div className="flex items-center gap-4" data-id="element-248" data-mp="1omkjlbjp8w8u">
                <span aria-hidden className="font-jp text-4xl text-crimson lg:text-5xl" data-id="element-249" data-mp="1ojzgkj7o0a9i">
                  {HERO.kanji}
                </span>
                <span className="font-display text-xs uppercase tracking-[0.3em] text-gold" data-id="element-250" data-mp="1fkukdjjkst0i">
                  Zanshin · l’esprit toujours présent
                </span>
              </div>

              <h1 className="mt-6 font-display text-3xl font-bold leading-tight text-bone sm:text-4xl lg:text-[2.9rem]" data-id="element-251" data-mp="28atazjdf4y7a">
                {HERO.quote}
              </h1>
              <p className="mt-3 text-xs uppercase tracking-[0.16em] text-muted" data-id="element-252" data-mp="1tjkovk8q5uyw">{HERO.quoteAuthor}</p>

              <p className="mt-8 max-w-xl text-sm leading-relaxed text-muted lg:text-base" data-id="element-253" data-mp="2ma2rkk5jdubs">{HERO.intro}</p>

              <div className="mt-9 flex flex-wrap gap-3" data-id="element-254" data-mp="2r0j5s6h6ljz7">
                <Link to="/informations-pratiques#inscription" className="zk-focus inline-flex items-center gap-2 bg-gold px-6 py-3 font-display text-sm font-semibold uppercase tracking-[0.14em] text-ink transition-colors duration-150 ease-out hover:bg-gold-soft" data-id="element-255" data-mp="2r240px7er4xl">
                  Rejoindre le dojo
                  <ArrowRightIcon size={16} aria-hidden data-id="element-256" data-mp="kc0qv436jr0l" />
                </Link>
                <Link to="/informations-pratiques#horaires" className="zk-focus inline-flex items-center gap-2 border border-gold/50 px-6 py-3 font-display text-sm font-semibold uppercase tracking-[0.14em] text-gold transition-colors duration-150 ease-out hover:bg-gold hover:text-ink" data-id="element-257" data-mp="3ssc74pjdtyub">
                  Voir les horaires
                </Link>
              </div>
            </div>

            <figure className="relative" data-id="element-258" data-mp="1h1rvhw56quk4">
              <div className="group relative aspect-video overflow-hidden border border-gold/25 bg-panel" data-id="element-259" data-mp="1h4w2t2dy66f0">
                <img src={HERO.image} alt="Aperçu de la vidéo de présentation du Zanshin Karaté Club" className="h-full w-full object-cover opacity-70 transition-transform duration-300 ease-out group-hover:scale-[1.03]" data-id="element-260" data-mp="1c62udodip5lp" />
                <button type="button" className="zk-focus absolute inset-0 flex items-center justify-center bg-ink/40" data-id="element-261" data-mp="2hefcg5hhfxqc">
                  <span className="sr-only" data-id="element-262" data-mp="2qc7qz7fdr1co">Lire la vidéo de présentation du club</span>
                  <span aria-hidden className="inline-flex h-16 w-16 items-center justify-center rounded-full border border-gold bg-ink/70 text-gold transition-colors duration-150 ease-out group-hover:bg-gold group-hover:text-ink" data-id="element-263" data-mp="2vaj1zlhevhwh">
                    <PlayIcon size={26} data-id="element-264" data-mp="3a1rqtsdhoz8k" />
                  </span>
                </button>
              </div>
              <figcaption className="mt-3 text-xs uppercase tracking-[0.16em] text-muted" data-id="element-265" data-mp="3e34rlo1q6c8m">
                Vidéo de présentation — saison 2026-2027
              </figcaption>
            </figure>
          </motion.div>
        </div>
      </section>

      <section aria-label="Le club en chiffres" className="border-b border-gold/15 bg-panel" data-id="element-266" data-mp="tea8pmxhs2uc">
        <div className="mx-auto max-w-shell px-5 lg:px-8" data-id="element-267" data-mp="of71bvu1hkj7">
          <dl className="grid divide-y divide-gold/10 sm:grid-cols-2 sm:divide-x lg:grid-cols-5 lg:divide-y-0" data-id="element-268" data-mp="ogrv3j8j4zg0">
            {KEY_FIGURES.map(fig => <div key={fig.label} className="px-2 py-7 text-center sm:px-6" data-id="element-269" data-mp="1h44g3oz1kz77">
                <dt className="sr-only" data-id="element-270" data-mp="1h68nwi02aicr">{fig.label}</dt>
                <dd data-id="element-271" data-mp="1cbuweqoisvdd">
                  <span className="block font-display text-3xl font-bold text-gold" data-id="element-272" data-mp="1cbbbd13kpqv4">{fig.value}</span>
                  <span className="mt-2 block text-xs uppercase tracking-[0.14em] text-muted" data-id="element-273" data-mp="17byt6tnnd7yv">{fig.label}</span>
                </dd>
              </div>)}
          </dl>
        </div>
      </section>

      <section className="relative overflow-hidden border-b border-gold/15" data-id="element-274" data-mp="200xchu3iag5r">
        <span aria-hidden className="pointer-events-none absolute -right-8 bottom-0 select-none font-jp text-[10rem] leading-none text-white/[0.04] lg:text-[16rem]" data-id="element-275" data-mp="3ub43hpgw3aov">
          道場訓
        </span>
        <div className="relative mx-auto max-w-shell px-5 py-16 lg:px-8 lg:py-24" data-id="element-276" data-mp="3kiye8ni0v7dd">
          <SectionHeading kanji="道場訓" title="Dōjō Kun — le code de conduite" description="Récités à la fin de chaque cours, les sept préceptes du Bushido incarnés par le samouraï de notre logo guident la pratique bien au-delà du tatami." data-id="element-277" data-mp="3pi1779kq9n4z" />

          <ol className="mt-12 divide-y divide-gold/10 border-y border-gold/10" data-id="element-278" data-mp="31nhshw5c13rz">
            {DOJO_KUN.map((precept, index) => <li key={precept.romaji} className="grid items-baseline gap-2 py-6 md:grid-cols-[3rem_5rem_1fr_1.4fr] md:gap-8" data-id="element-279" data-mp="zuk5igy8l5ey" data-mpi={index}>
                <span className="font-display text-sm text-gold-dim" data-id="element-280" data-mp="14svd0l1273u0">{String(index + 1).padStart(2, '0')}</span>
                <span aria-hidden className="font-jp text-3xl text-crimson" data-id="element-281" data-mp="1evh41p05c8og">
                  {precept.kanji}
                </span>
                <span data-id="element-282" data-mp="1nqf55jdg6rqv">
                  <span className="block font-display text-lg uppercase tracking-[0.06em] text-bone" data-id="element-283" data-mp="1nqx5ar38dq42">
                    {precept.title}
                  </span>
                  <span className="mt-1 block text-xs uppercase tracking-[0.18em] text-gold-dim" data-id="element-284" data-mp="1xnt76dymjdzn">{precept.romaji}</span>
                </span>
                <span className="text-sm leading-relaxed text-muted" data-id="element-285" data-mp="1so6v47uj83sf">{precept.text}</span>
              </li>)}
          </ol>
        </div>
      </section>

      <section className="border-b border-gold/15 bg-panel" data-id="element-286" data-mp="22mmnee5apj3i">
        <div className="mx-auto max-w-shell px-5 py-16 lg:px-8 lg:py-20" data-id="element-287" data-mp="22l1qihvido2h">
          <div className="flex flex-wrap items-end justify-between gap-4" data-id="element-288" data-mp="cb8l27hd356y">
            <SectionHeading kanji="報" title="Actualités du club" data-id="element-289" data-mp="89wp7k7w9nqb" />
            <Link to="/calendrier" className="zk-focus inline-flex items-center gap-2 font-display text-sm uppercase tracking-[0.14em] text-gold hover:text-gold-soft" data-id="element-290" data-mp="wu32ilot6e46">
              Tout le calendrier
              <ArrowRightIcon size={16} aria-hidden data-id="element-291" data-mp="16l63zolngv3z" />
            </Link>
          </div>

          <ul className="mt-10 grid gap-6 md:grid-cols-3" data-id="element-292" data-mp="1alq3uzxlyctt">
            {NEWS.map(item => <li key={item.title} className="flex h-full flex-col border border-white/5 bg-ink" data-id="element-293" data-mp="dvz8yzlemnnh">
                <img src={item.image} alt="" className="h-44 w-full object-cover" data-id="element-294" data-mp="itim1w6d8udu" />
                <div className="flex flex-1 flex-col p-6" data-id="element-295" data-mp="mvdwbq69yi3r">
                  <p className="text-xs uppercase tracking-[0.16em] text-gold-dim" data-id="element-296" data-mp="my01xk9lunjc">{item.date}</p>
                  <h3 className="mt-3 font-display text-lg leading-snug text-bone" data-id="element-297" data-mp="rsvuqmmo1exi">{item.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-muted" data-id="element-298" data-mp="1yd57qx519276">{item.text}</p>
                </div>
              </li>)}
          </ul>
        </div>
      </section>

      <section className="mx-auto max-w-shell px-5 py-16 lg:px-8 lg:py-20" data-id="element-299" data-mp="2ddki7vufoxju">
        <SectionHeading kanji="案内" title="Tout le club en un coup d’œil" description="Adhérents, parents, futurs pratiquants ou partenaires : chaque rubrique du site rassemble les informations dont vous avez besoin." data-id="element-300" data-mp="28g0snzsacycl" />
        <ul className="mt-10 grid gap-px border border-gold/10 bg-gold/10 sm:grid-cols-2 lg:grid-cols-4" data-id="element-301" data-mp="1unkubcabxoi0">
          {RUBRIQUES.map(({
          to,
          label,
          text,
          Icon
        }) => <li key={to} className="bg-ink" data-id="element-302" data-mp="1pn6l3qwzs8ie">
              <Link to={to} className="zk-focus group flex h-full flex-col p-7 transition-colors duration-150 ease-out hover:bg-panel" data-id="element-303" data-mp="1kp56bi6lmvcq">
                <Icon size={24} className="text-gold" aria-hidden data-id="element-304" data-mp="3f3fr9fk2p5d8" />
                <span className="mt-5 font-display text-base uppercase tracking-[0.08em] text-bone" data-id="element-305" data-mp="3f2mth433dq78">{label}</span>
                <span className="mt-3 text-sm leading-relaxed text-muted" data-id="element-306" data-mp="3azq48uj1qvub">{text}</span>
                <span className="mt-auto pt-6 text-gold" data-id="element-307" data-mp="cms1b5jd0t8v">
                  <ArrowRightIcon size={18} aria-hidden className="transition-transform duration-150 ease-out group-hover:translate-x-1" data-id="element-308" data-mp="8nri3lwyzolc" />
                </span>
              </Link>
            </li>)}
        </ul>
      </section>

      <section className="border-t border-gold/15 bg-panel" data-id="element-309" data-mp="3q49g55fwlik1">
        <div className="mx-auto flex max-w-shell flex-col items-start gap-6 px-5 py-14 lg:flex-row lg:items-center lg:justify-between lg:px-8" data-id="element-310" data-mp="3l4ohyx8k5e8d">
          <div data-id="element-311" data-mp="3pho3emzeu1b">
            <h2 className="font-display text-2xl uppercase tracking-[0.06em] text-bone" data-id="element-312" data-mp="3p7znvhl4uxq">
              Deux cours d’essai gratuits, toute l’année
            </h2>
            <p className="mt-3 max-w-xl text-sm leading-relaxed text-muted" data-id="element-313" data-mp="37byhxow728s9">
              Dès 7 ans, en loisir ou en compétition : venez pousser la porte du dojo, une tenue de sport suffit.
            </p>
          </div>
          <Link to="/contact" className="zk-focus inline-flex items-center gap-2 bg-crimson px-7 py-3 font-display text-sm font-semibold uppercase tracking-[0.14em] text-white transition-colors duration-150 ease-out hover:bg-crimson-dim" data-id="element-314" data-mp="1hubf1kf4jrs7">
            Nous contacter
            <ArrowRightIcon size={16} aria-hidden data-id="element-315" data-mp="1cxb9rbq3mt25" />
          </Link>
        </div>
      </section>
    </>;
}